const spotActions = {
    sendAll : {
        ACTION_INIT : 'action_send_all_init',
        ACTION_PENDING : 'action_send_all_pending',
        ACTION_SUCCESS : 'action_send_all_success',
        ACTION_FAILED : 'action_send_all_failed',
    },
}

export default spotActions;